import { useTranslation } from 'react-i18next';

import AddContractModal from '../../../styledComponents/Modals/AddContractModal/AddContractModal';
import FormErrorProvider from '../../../styledComponents/FormErrorProvider/FormErrorProvider';
import Header from '../../../styledComponents/PageDetails/HeaderPageDetails/HeaderPageDetails';
import { SubscriptionPricingFormFields } from '../../../styledComponents/SubscriptionFormPage/FormSections/AirAmbulanceSubscription/SubscriptionPricingForm/subscriptionPricingForm.models';
import { useEditAASubscriptionPage } from './editAASubscriptionPage.hooks';
import EditProductSubscriptionForm from './EditAASubscriptionForm/EditAASubscriptionForm';

const EditAASubscriptionPage = () => {
  const { t } = useTranslation();
  const {
    organizationName,
    subscriptionType,
    loadDatesForNewSubscriptionHandler,
  } = useEditAASubscriptionPage();

  return (
    <FormErrorProvider
      initErrorGroups={[SubscriptionPricingFormFields.Pricing]}
    >
      <AddContractModal />
      <Header
        title={t('headers.edit-product-subscription', {
          organizationName,
          subscriptionType,
        })}
      />

      <EditProductSubscriptionForm
        onContractChanged={loadDatesForNewSubscriptionHandler}
      />
    </FormErrorProvider>
  );
};

export default EditAASubscriptionPage;
